import * as yup from 'yup';

export const BulkDeviceEditValidation = yup.object({
    deviceId: yup.array().of(yup.string()).min(1).required(),
    managerId: yup.string().required(),
});